// SearchContext.js
import React, { createContext, useContext, useState } from "react";

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
    const [userAdminData, setUserAdminData] = useState(null)
      const [token, setToken] = useState(null);


  const updateSearchQuery = (query) => {
    setSearchQuery(query);
  };

  return (
    <SearchContext.Provider
      value={{
        searchQuery,
        updateSearchQuery,
        loading,
        setLoading,
        userAdminData,
        setUserAdminData,
        token,
        setToken,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  return useContext(SearchContext);
};
